
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"320","height":"140"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('rect',{attrs:{"data-name":"사각형 2962","width":"320","height":"140","rx":"10","transform":"translate(20 95)","fill":"#234a63"}})])]),_c('g',{attrs:{"data-name":"그룹 2260","transform":"translate(-20 -98)"}},[_c('rect',{attrs:{"data-name":"사각형 2948","width":"320","height":"140","rx":"10","transform":"translate(20 98)","fill":"#234a63"}}),_c('path',{attrs:{"data-name":"사각형 2957","d":"M262 214h2a4 4 0 014 4v20h-10v-20a4 4 0 014-4z","fill":"#1b3a4e"}}),_c('path',{attrs:{"data-name":"사각형 2958","d":"M282 184h2a4 4 0 014 4v50h-10v-50a4 4 0 014-4z","fill":"#1b3a4e"}}),_c('path',{attrs:{"data-name":"사각형 2961","d":"M242 200h2a4 4 0 014 4v34h-10v-34a4 4 0 014-4z","fill":"#1b3a4e"}}),_c('path',{attrs:{"data-name":"사각형 2959","d":"M302 204h2a4 4 0 014 4v30h-10v-30a4 4 0 014-4z","fill":"#1b3a4e"}}),_c('path',{attrs:{"data-name":"사각형 2960","d":"M322 194h2a4 4 0 014 4v40h-10v-40a4 4 0 014-4z","fill":"#1b3a4e"}}),_c('g',{attrs:{"data-name":"마스크 그룹 47","transform":"translate(0 3)","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"패스 1370","d":"M378.005 194.656l-80.005-50-79.995 50","fill":"none","stroke":"#1d3c50","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"10"}})])])])
          )
        }
      }
    